import React from 'react';
import Stack, { StackProps } from '../Stack/Stack';
import Text from '../Text/Text';

type Props = {
  /** The title of the page */
  title: string;

  /** An optional page subtitle */
  subtitle?: string;
} & StackProps;

const PageHeader = ({ title, subtitle, ...rest }: Props) => {
  return (
    <Stack borderColor="gray-100" space={1} {...rest}>
      {title && <Text variant="h3">{title}</Text>}
      {subtitle && <Text muted>{subtitle}</Text>}
    </Stack>
  );
};

PageHeader.displayName = 'PageHeader';
export default PageHeader;
